import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import srTranslation from './translations/sr';

const resources = {
  sr: {
    translation: srTranslation,
  }
};

const currentTranslation = () =>
  localStorage.getItem('translation')
    ? localStorage.getItem('translation')
    : localStorage.setItem('translation', 'sr');

i18n.use(initReactI18next).init({
  resources,
  lng: currentTranslation(),
  fallbackLng: 'sr',

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
